import React from "react";

/**
 * BrandDivider · subtle graphic recurso
 * Concept: 'constancia + estirada'
 *   → three parallel equidistant lines (consistency)
 *   → one single continuous line crossing side-to-side (the dive)
 *
 * Uniform stroke, rounded caps. Decorative layer (pointer-events disabled via class).
 */
const BrandDivider = ({ className = "", color = "currentColor", opacity = 0.35 }) => {
  return (
    <div
      aria-hidden="true"
      className={`deco-layer w-full ${className}`}
      style={{ color }}
    >
      <svg
        viewBox="0 0 1200 60"
        width="100%"
        height="60"
        preserveAspectRatio="none"
        role="presentation"
      >
        <g
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
          opacity={opacity}
        >
          {/* three parallel equidistant lines */}
          <line x1="0" y1="14" x2="1200" y2="14" />
          <line x1="0" y1="26" x2="1200" y2="26" />
          <line x1="0" y1="38" x2="1200" y2="38" />
          {/* one continuous diagonal line — the dive */}
          <line x1="0" y1="52" x2="1200" y2="8" opacity="0.9" />
        </g>
      </svg>
    </div>
  );
};

export default BrandDivider;
